/**
 * Doomsworn — PILLAR III: CAST. Safe, weak, deniable.
 *
 * Human scholarship from the young kingdoms. It works because it asks nobody
 * for anything, and it is weak for exactly that reason.
 *
 * This is the ONLY place in Doomsworn where spell slots exist. Ordinary
 * prepared slots and spell lists, Open5e spells filtered to levels 1–5 —
 * humanity has not got further. Alone among the three pillars, it can fail.
 * No Debt, no Grip, no soul-cost. Nothing owns you.
 *
 * Its real strategic value: a cast spell leaves no ledger entry anywhere in
 * the cosmos. It is the only magic the Powers cannot trace.
 */
import { tiltCastModifier } from './tilt.js';
/** Humanity has not got past 5th. Open5e spells above this are unavailable. */
export const CAST_MAX_SPELL_LEVEL = 5;
/**
 * Slots by advancement step (1..10), levels 1–5 only. Deliberately thinner
 * than a 5e full caster: Cast is the mundane pillar.
 */
export const CAST_SLOT_TABLE = {
    1: { 1: 2 },
    2: { 1: 3 },
    3: { 1: 3, 2: 2 },
    4: { 1: 4, 2: 2 },
    5: { 1: 4, 2: 3, 3: 2 },
    6: { 1: 4, 2: 3, 3: 3 },
    7: { 1: 4, 2: 3, 3: 3, 4: 1 },
    8: { 1: 4, 2: 3, 3: 3, 4: 2 },
    9: { 1: 4, 2: 3, 3: 3, 4: 3, 5: 1 },
    10: { 1: 4, 2: 3, 3: 3, 4: 3, 5: 2 },
};
export function getCastSlots(step) {
    const clamped = Math.max(1, Math.min(10, Math.floor(step)));
    return { ...(CAST_SLOT_TABLE[clamped] ?? {}) };
}
/** Cast rolls to work at all. DC rises with spell level. */
export function castDC(spellLevel) {
    return 10 + spellLevel * 2;
}
/**
 * Roll to make a written spell work. Better under Law (Cast is formal),
 * worse under Chaos (it is written down, and Chaos objects to that on
 * principle).
 */
export function resolveCastCheck(input) {
    const rng = input.rng ?? Math.random;
    const natural = Math.floor(rng() * 20) + 1;
    const tiltModifier = input.tilt === undefined ? 0 : tiltCastModifier(input.tilt);
    const total = natural + input.abilityMod + tiltModifier;
    const dc = castDC(input.spellLevel);
    const success = natural !== 1 && (natural === 20 || total >= dc);
    return {
        success,
        natural,
        total,
        dc,
        tiltModifier,
        slotSpent: true,
        description: success
            ? `The formula holds (${total} vs DC ${dc}). Nothing is owed and nothing was noticed.`
            : `The formula does not hold (${total} vs DC ${dc}). The slot is gone regardless.`,
    };
}
//# sourceMappingURL=cast.js.map